import axios from 'axios'
import cookies from '../assets/js/cookies.js'
import {Message} from 'element-ui'
import router from '../router/index'
let that = this
// 创建 axios 实例
const service = axios.create({
baseURL: process.env.baseUrl, // 固定url
// baseURL: window.location.origin  + '/api/', // 动态获取url
})
// 请求拦截器
service.interceptors.request.use((config) => {
    // 动态设置请求头
    if(cookies.getCookie("token")){
        config.headers.common = {
            Authorization: cookies.getCookie("token"),
        }
    }
    if (config.method === 'post') {
        config.data = {
        ...config.data,
        t: Date.parse(new Date())
        }
    } else if (config.method === 'get') {
        config.params = {
        ...config.params,
        t: Date.parse(new Date())
        }
    }
    return config
}, (err) => {
    return Promise.reject(err)
})

// 响应拦截器
service.interceptors.response.use((res) => {
    if (res.data.code == 0) {
        // 请求成功，正常返回
        return res.data
    }else if (res.data.code == -999) {
        // token失效，清除cookie
        cookies.logoutClearCookie();
        // 跳转check
        router.replace({
            name: 'login',
        })
    }else{
        // 请求失败
        Message.error(res.data.message);
        return Promise.reject(res);
    }
}, (err) => {
  // 接口请求失败（404或500的情况）
  return Promise.reject(err)
})


export default service


// WEBPACK FOOTER //
// ./src/api/index.js